import * as React from 'react';
import Traveller from './Traveller/Traveller';
import { Form } from 'react-final-form';
import { Button, Money } from '@websky/core';
import Modal from '@websky/core/src/Modal';
import css from './PassengersCheckPopup.css';
import { format } from '@websky/core/src/utils';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import PriceWithSubsidy from './PriceWithSubsidy/PriceWithSubsidy';
var PassengersCheckPopup = function (_a) {
    var _b;
    var subsidyInfo = _a.subsidyInfo, onNext = _a.onNext, onClose = _a.onClose;
    var onSubmit = function (values) {
        var passengerForSegment = new Map();
        subsidyInfo.segments.forEach(function (segment, segmentIndex) {
            segment.travellers
                .filter(function (traveller, travellerIndex) {
                var _a, _b, _c, _d;
                return (_d = (_c = (_b = (_a = values === null || values === void 0 ? void 0 : values.segments) === null || _a === void 0 ? void 0 : _a[segmentIndex]) === null || _b === void 0 ? void 0 : _b.travellers) === null || _c === void 0 ? void 0 : _c[travellerIndex]) === null || _d === void 0 ? void 0 : _d.check;
            })
                .forEach(function (traveller) {
                var key = "".concat(traveller.traveller.id, "_").concat(traveller.subsidyInfo.subsidyId);
                var obj = passengerForSegment.get(key) || {
                    passengerId: traveller.traveller.id,
                    segments: [],
                    subsidyId: traveller.subsidyInfo.subsidyId
                };
                obj.segments.push(segment.segment.id);
                passengerForSegment.set(key, obj);
            });
        });
        var selectedPassengerSubsidies = [];
        passengerForSegment.forEach(function (passenger) { return selectedPassengerSubsidies.push(passenger); });
        onNext(selectedPassengerSubsidies);
    };
    var t = useTranslation('Subsidy').t;
    var initialValues = React.useMemo(function () {
        var values = {
            segments: subsidyInfo.segments.map(function (segment) {
                return {
                    travellers: segment.travellers.map(function (traveller) {
                        var _a;
                        return {
                            check: traveller.subsidyInfo &&
                                !traveller.subsidyInfo.rejectMessage &&
                                ((_a = traveller.subsidyInfo.discount) === null || _a === void 0 ? void 0 : _a.amount) > 0
                        };
                    })
                };
            })
        };
        return values;
    }, [subsidyInfo]);
    var closeIconRender = function (onClick) {
        return React.createElement("div", { className: css.close, onClick: onClick });
    };
    var isOneSubsidyExists = (_b = subsidyInfo === null || subsidyInfo === void 0 ? void 0 : subsidyInfo.segments) === null || _b === void 0 ? void 0 : _b.some(function (segment) {
        return segment === null || segment === void 0 ? void 0 : segment.travellers.some(function (traveller) { var _a, _b; return ((_b = (_a = traveller.subsidyInfo) === null || _a === void 0 ? void 0 : _a.discount) === null || _b === void 0 ? void 0 : _b.amount) > 0; });
    });
    return (React.createElement(Modal, { open: true, isRounded: true, onClose: onClose, classes: {
            paper: css.paperModal,
            root: css.dialog
        }, closeButtonRenderer: closeIconRender },
        React.createElement("div", { className: css.container },
            React.createElement("h2", { className: css.header }, t('Choose subsidies for flights')),
            React.createElement(Form, { onSubmit: onSubmit, initialValues: initialValues }, function (form) {
                var _a;
                return (React.createElement("form", { onSubmit: form.handleSubmit },
                    subsidyInfo.segments.map(function (segment, segmentId) {
                        return (React.createElement("div", { key: segment.segment.id },
                            React.createElement("div", { className: css.segment },
                                React.createElement("div", { className: css.segment__direction },
                                    segment.segment.departure.airport.city.name,
                                    " -",
                                    ' ',
                                    segment.segment.arrival.airport.city.name),
                                React.createElement("div", { className: css.segment__date }, format(segment.segment.departure.date, 'dd MMM, yyyy'))),
                            React.createElement("div", null, segment.travellers.map(function (traveller, travellerId) {
                                return (React.createElement(Traveller, { traveller: traveller.traveller, segmentIndex: segmentId, travellerIndex: travellerId, key: traveller.traveller.id, subsidyInfo: traveller.subsidyInfo }));
                            }))));
                    }),
                    React.createElement("h3", { className: css.totalCost }, t('Total price')),
                    React.createElement("div", { className: css.totalCost__item },
                        React.createElement("div", null, t(isOneSubsidyExists ? 'total price for flight' : 'total price without subsidies')),
                        React.createElement(Money, { money: subsidyInfo.initialOrderPrice, moneyClassName: cn(css.money, (_a = {}, _a[css.money_old] = isOneSubsidyExists, _a)) })),
                    isOneSubsidyExists && (React.createElement("div", { className: css.totalCost__item },
                        React.createElement("div", null, t('total price for flight with subsidy')),
                        React.createElement(PriceWithSubsidy, { totalPrice: subsidyInfo.initialOrderPrice, subsidyInfo: subsidyInfo }))),
                    React.createElement("div", null,
                        React.createElement(Button, { className: css.button, type: "submit", variant: "flat" }, t('Continue')))));
            }))));
};
export default PassengersCheckPopup;
